module.exports = __webpack_public_path__ + "img/everydayink-mobile.d4cb5bbc.jpg";